import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
/**
 * 상품 유의사항 스크롤 박스 (패키지 주문 / 월구독 패키지 공용)
 *
 * 본문 길이가 상품마다 크게 달라 높이를 고정하고 내부 스크롤로 처리한다.
 * description 은 개행이 의미를 가지므로 whitespace-pre-line 을 유지한다.
 *
 * PackageItemRow(OrderItemRow.tsx)와 SubscriptionItemRow 양쪽이 쓰기 때문에
 * 어느 한쪽에 두면 순환 import 가 되어 별도 파일로 뺐다.
 */ const ProductNoticeBox = (param)=>/*#__PURE__*/ {
    let { description  } = param;
    return _jsx("div", {
        className: "w-full h-[200px] bg-gray-0 rounded-md overflow-scroll custom-scrollbar",
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "body2",
            className: "text-secondary whitespace-pre-line p-4",
            children: description
        })
    });
};
export default ProductNoticeBox;
